<div class="container text-center pb-5">
  <div class="d-inline-block song-wrapper">
    <h2 class="h4 mb-4">{{ song.title }}</h2>
    <p *ngIf="song?.melody"><i>{{ song.melody }}</i></p>
    <div [innerHtml]="song?.text" class="song-container"></div>
    <p *ngIf="song?.credits">{{ song.credits }}</p>
  </div>
  <a routerLink="/alle-vers" class="d-block mt-3"><i class="fas fa-arrow-left mr-2"></i> Alle bordvers</a>
</div>